module.exports = __webpack_public_path__ + "img/two.b0f32d39.jpg";